var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHopitalIndemnity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "presentation",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 42.7778H42.7778V58.3333H27.2222V42.7778H11.6667V27.2222H27.2222V11.6667H42.7778V27.2222H58.3333M62.2222 0H7.77778C3.46111 0 0 3.46111 0 7.77778V62.2222C0 64.285 0.819442 66.2633 2.27806 67.7219C3.73667 69.1806 5.71498 70 7.77778 70H62.2222C64.285 70 66.2633 69.1806 67.7219 67.7219C69.1806 66.2633 70 64.285 70 62.2222V7.77778C70 3.46111 66.5 0 62.2222 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHopitalIndemnity);
export default __webpack_public_path__ + "static/media/icon-hopital-indemnity.ada77bc4589235fb99204c3f74988b5e.svg";
export { ForwardRef as ReactComponent };